import { c as _c } from "react/compiler-runtime";
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { INVESTIGATION_CHAT_PARAM } from '@/config/constants';
import useMobileLayout from '@/hooks/use-mobile-layout';
import useChatWidgetOpen from './use-chat-widget-open';
const useMobileChatNavigation = () => {
  const $ = _c(6);
  const isMobile = useMobileLayout();
  const {
    events,
    asPath
  } = useRouter();
  const {
    close
  } = useChatWidgetOpen();
  let t0;
  let t1;
  if ($[0] !== asPath || $[1] !== close || $[2] !== events || $[3] !== isMobile) {
    t0 = () => {
      if (!isMobile) {
        return;
      }
      const onNavigate = url => {
        if (revealsPage(asPath, url)) {
          close();
        }
      };
      events.on("routeChangeStart", onNavigate);
      return () => events.off("routeChangeStart", onNavigate);
    };
    t1 = [isMobile, events, asPath, close];
    $[0] = asPath;
    $[1] = close;
    $[2] = events;
    $[3] = isMobile;
    $[4] = t0;
    $[5] = t1;
  } else {
    t0 = $[4];
    t1 = $[5];
  }
  useEffect(t0, t1);
};

/**
 * Whether a navigation asks the page for something the fullscreen chat would hide: another page, or
 * a param it adds or changes on this one (an artifact to open). The chat's own `?chat=` updates, and
 * updates that only drop a param, keep it open.
 */
const revealsPage = (from: string, to: string): boolean => {
  const current = new URL(from, window.location.origin);
  const next = new URL(to, window.location.origin);
  if (next.pathname !== current.pathname) return true;
  return Array.from(next.searchParams.entries()).some(([key, value]) => key !== INVESTIGATION_CHAT_PARAM && current.searchParams.get(key) !== value);
};
export default useMobileChatNavigation;